import Box, { type BoxProps } from '@liquidweb-dev/undercurrent/Box';
import AcronisEdrBlock from 'images/acronis-edr-block.webp';
import AdvancedDdosBlock from 'images/advanced-ddos-block.png';
import Imunify360Block from 'images/imunify360-block.webp';
import ThreatDownBlock from 'images/threatdown-block.webp';

/**
 * @typedef ProductBrandBlockProps
 * @property {string} code the package or product code
 */

/** @param {ProductBrandBlockProps & import('@liquidweb-dev/undercurrent/Box').BoxProps} props */

export interface ProductBrandBlockProps extends BoxProps {
	code: string;
}

const ProductBrandBlock = ({ code, ...rest }: ProductBrandBlockProps) => {
	if (['PKG-ThreatDown'].includes(code)) {
		return (
			<Box component="img" src={ThreatDownBlock} alt="Threatdown" {...rest} />
		);
	}

	if (['PKG-Imunify360'].includes(code)) {
		return (
			<Box component="img" src={Imunify360Block} alt="Imunify360" {...rest} />
		);
	}

	if (['PKG-DDoS.Server.Protect'].includes(code)) {
		return (
			<Box component="img" src={AdvancedDdosBlock} alt="Corero" {...rest} />
		);
	}

	if (['PKG-AcronisEDR'].includes(code)) {
		return (
			<Box
				component="img"
				src={AcronisEdrBlock}
				alt="Acronis Endpoint Detection & Response"
				{...rest}
			/>
		);
	}

	return null;
};

export default ProductBrandBlock;
